/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical';
import {
  useEffect,
  useLayoutEffect,
  useRef
} from 'react';

function ControlledValuePlugin({ value, isReadOnly }: { value: string; isReadOnly: boolean }) {
  const [editor] = useLexicalComposerContext();
  const isReadOnlyRef = useRef(isReadOnly);

  useLayoutEffect(() => {
    isReadOnlyRef.current = isReadOnly;
  }, [isReadOnly]);

  // When read-only: revert any editor update back to the previous state.
  // This blocks all mutations (keystrokes, paste, drag-drop, undo, etc.) without disabling focus or the caret.
  useLayoutEffect(() => {
    return editor.registerUpdateListener(({ prevEditorState, tags }) => {
      if (!isReadOnlyRef.current) return;
      if (tags.has('controlled-sync')) return;
      if (prevEditorState.isEmpty()) return;
      editor.setEditorState(prevEditorState);
    });
  }, [editor]);

  useEffect(() => {
    const currentText = editor.getEditorState().read(() => $getRoot().getTextContent());
    if (currentText === value) return;

    editor.update(
      () => {
        const root = $getRoot();
        root.clear();
        const paragraph = $createParagraphNode();
        if (value) paragraph.append($createTextNode(value));
        root.append(paragraph);
      },
      { discrete: true, tag: 'controlled-sync' },
    );
  }, [editor, value]);

  return null;
}

export { ControlledValuePlugin };
